// extracted by mini-css-extract-plugin
export default {"root":"ReportLogo__root--xxCoAI","contactInfo":"ReportLogo__contactInfo--ygDx-r"};